export default function () {
  const onSlideDownEnd = (button, panel) => {
    return function onSlideDownTransitionEnd() {
      if (button.classList.contains('active')) {
        panel.style.height = '';
      }
    };
  };

  const slideDown = (button, panel) => {
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert');
    panel.style.height = panel.scrollHeight + 'px';

    panel.removeEventListener('transitionend', onSlideDownEnd);
    panel.addEventListener('transitionend', onSlideDownEnd(button, panel), { once: true });
  };

  const slideUp = (button, panel) => {
    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');
    panel.setAttribute('inert', '');
    panel.style.height = panel.scrollHeight + 'px';

    setTimeout(() => {
      panel.style.height = '0px';
    }, 1);
  };

  Array.from(document.querySelectorAll('[data-accordion-button]')).forEach(button => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));

    if (!button.classList.contains('active')) {
      panel.style.height = '0';
    }
    panel.classList.add('overflow-hidden', 'transition-all', 'duration-300');

    button.addEventListener('click', () => {
      if (!button.classList.contains('active')) {
        slideDown(button, panel);
      } else {
        slideUp(button, panel);
      }
    });
  });
}
